import { Entities } from '@inwink/entities/entities';
import { Link } from 'react-router-dom';
import { React, IPopoverManager, AppAsyncButton } from '@@commons';
import { i18NHelperContext } from '@@services/i18nservice';
import { ItemWebsite, IItemWebsiteProps } from './itemwebsite';

import './communityitem.less';

interface ICommunityItemProps {
    popovermgr: IPopoverManager;
    className?: string;
    popoverClassName?: string;
    communityitem: any;
    customerid: string;
    onRemove?: (communityitem: any) => any;
    style?: any;
    disableClick?: boolean;
    onClick?: (communityitem: any) => void;
    onAfterClick?: (communityitem: any) => void;
    children?: React.ReactNode;
}

export class CommunityItem extends React.Component<ICommunityItemProps, any> {
    eventClicked = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        this.props.onClick(this.props.communityitem);
    };

    afterClick = () => {
        if (this.props.onAfterClick) {
            this.props.onAfterClick(this.props.communityitem);
        }
    };

    openPreview = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        const props: IItemWebsiteProps = {
            item: this.props.communityitem,
            itemType: 'community'
        };

        this.props.popovermgr?.popoverPortal(arg.currentTarget, ItemWebsite, props, "itemwebsitepopover " + (this.props.popoverClassName || ""));
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    renderContent(i18n: Entities.i18nHelper) {
        const community = this.props.communityitem;
        const actionsItems = [];
        let actions = null;
        if (community.communityKey) {
            actionsItems.push(<AppAsyncButton
                key="openpreview"
                title="actions.openpreview"
                className="openpreview"
                onClick={this.openPreview}
            ><i className="inwink-web" /></AppAsyncButton>);
        }

        if (actionsItems.length) {
            actions = <div className="actions">{actionsItems}</div>;
        }

        return <>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110.91 110.91">
                <defs>
                    <style>{`.white {fill: #fff;} .logo-community {fill: var(--green);} .e {isolation: isolate; opacity: 0.9;`}</style>
                </defs>
                <g id="a"/>
                <g id="b">
                    <g id="c">
                    <path className="logo-community" d="M110.9,55.45c0,15.32,.51,33.15-10.89,44.59-11.4,11.44-29.25,10.86-44.56,10.86s-33.15,.51-44.59-10.89C-.58,88.62,0,70.77,0,55.45S-.5,22.3,10.9,10.86C22.3-.58,40.15,0,55.45,0s33.15-.5,44.59,10.9c11.44,11.4,10.86,29.25,10.86,44.55Z"/>
                        <g>
                            <path className="e" d="M54.48,84.02l16.38-28.38c2.34-4.06,.95-9.24-3.1-11.59-1.29-.75-2.76-1.14-4.25-1.14H30.75c-4.68,0-8.48,3.8-8.48,8.48,0,1.49,.39,2.95,1.14,4.24l16.38,28.38c2.34,4.06,7.53,5.45,11.59,3.11,1.29-.75,2.36-1.82,3.11-3.11Z"/>
                            <path className="white" d="M75.94,85.18l11.87-20.57c1.7-2.94,.69-6.7-2.25-8.4-.93-.54-1.99-.82-3.07-.82h-23.77c-3.4,0-6.14,2.77-6.13,6.17,0,1.07,.29,2.13,.82,3.06l11.88,20.57c1.7,2.94,5.47,3.95,8.41,2.24,.93-.54,1.71-1.31,2.24-2.24Z"/>
                            <circle className="e white" cx="47.13" cy="30.68" r="8.03"/>
                        </g>
                    </g>
                </g>
            </svg>
            <div className="communitydetail">
                <div className="communityname">
                    <div className="communityname-title">{community.name || community.title}</div>
                </div>
                {community?.authTenant?.name ? <div className="tenantname">
                    <div className="tenantname-title">{community.authTenant.name}</div>
                </div> : null}
            </div>
            {this.props.children ? <div className='childs'>{this.props.children}</div> : null}
            {actions}
        </>;
    }

    render() {
        const community = this.props.communityitem;

        if (this.props.disableClick) {
            return <div className={"community-item clickable " + (this.props.className || "")} style={this.props.style}>
                <i18NHelperContext.Consumer>
                    {(i18n) => this.renderContent(i18n)}
                </i18NHelperContext.Consumer>
            </div>;
        }

        if (this.props.onClick) {
            return <div
                className={"community-item clickable " + (this.props.className || "")}
                style={this.props.style}
                onClick={this.eventClicked}
            >
                <i18NHelperContext.Consumer>
                    {(i18n) => this.renderContent(i18n)}
                </i18NHelperContext.Consumer>
            </div>;
        }

        return <Link
            to={"/" + (community.customerId || this.props.customerid) + "/c/" + community.id}
            className={"community-item " + (this.props.className || "")}
            style={this.props.style}
            onClick={this.afterClick}
        >
            <i18NHelperContext.Consumer>
                {(i18n) => this.renderContent(i18n)}
            </i18NHelperContext.Consumer>
        </Link>;
    }
}
